// pub-sub-group-items
export const groupName = 'group-items'
export const subGroupItems = 'sub-group-items'

// pub-sub-no-limit
export const pubNoLimit = 'pub-no-limit'
export const subNoLimit = 'sub-no-limit'

// pub-sub-private
export const pubPrivate = 'pub-private-token'
export const subPrivate = 'sub-private-token'
export const subPrivateResult = 'sub-private-result'
export const syncToken = 'sync-private-token'

// pub-sub-zod-schema
export const pubZodAllow = 'pub-zod-allow'
export const pubZodSchema = 'pub-zod-schema'
export const subZodSchema = 'sub-zod-schema'
export const subZodSchemaResult = 'sub-zod-schema-result'

// tabs
export const tabItem = 'tab-item'
export const tabsContainer = 'tabs-container'
export const tabsPick = 'tabs-pick'

// toast
export const toastClose = 'toast-close'
export const toastItem = 'toast-item'
export const toastOpen = 'toast-open'
export const toastOpenResult = 'toast-open-result'
